import React, {Fragment} from "react";
import {
    TIPO_ELEMENTO_BTN_AGGIUNGI,
} from "../../../../utility/common";
import {Dialog} from 'primereact/dialog';
import ModalMsg from "../../../../components/ModalMsg";
import ModalUpdElementoKpiController from "./ModalUpdElementoKpiController";

export default function TabellaKpiConfView({
                                               tabella,
                                               elementoDettagli,
                                               showDettagli,
                                               getIconaDettaglio,
                                               getClasse,
                                               getClasseAllineamentoEl,
                                               getValoreByTipo,
                                               onHideDialog,
                                               aggiungiRiga,
                                               modalMsg,
                                               showMsg,
                                               setShowMsg,
                                               showModalUpdateElemento,
                                               showModalUpdEl,
                                               elementoSelezionato,
                                               hideModalUpdateElemento,
                                               handlerChange,
                                               handlerErrorUpdateElemento,
                                           }) {

    function disegnaValoreElemento(el) {
        if (el.topics_valori && el.topics_valori.length > 0) {
            /*
             * =================================
             * ===== Gestione ESRS
             * =================================
             */
            return (
                <div
                    className={"sost-cella-val-kpi text-start"}
                    onClick={() => {
                        showModalUpdateElemento(el);
                    }}
                >
                    <ul>
                        {
                            JSON.parse(JSON.stringify(el.topics_valori))
                                .reduce((acc, curr) => {
                                    const {id_topic, value} = curr;
                                    if (acc[id_topic]) {
                                        acc[id_topic].value += '; ' + value;
                                    } else {
                                        acc[id_topic] = curr;
                                    }
                                    return acc;
                                }, [])
                                .map((valTopic) => (
                                    <li key={valTopic.id_topic}>
                                        <strong>{valTopic.descr_topic}:&nbsp;</strong>
                                        {valTopic.value}
                                    </li>
                                ))
                        }
                    </ul>
                </div>
            );
        } else {
            return (
                <div
                    className={"sost-cella-val-kpi h-100 " + getClasseAllineamentoEl(el)}
                    onClick={() => {
                        showModalUpdateElemento(el);
                    }}
                >
                    {getValoreByTipo(el)}
                    {getIconaDettaglio(el)}
                </div>
            );
        }
    }

    function disegnaElemento(el) {
        if (parseInt(el.tipo) === TIPO_ELEMENTO_BTN_AGGIUNGI) {
            return (
                <div
                    className={"w-100 text-center"}
                >
                    <i
                        className="fas fa-plus-circle ns-mouse-pointer"
                        style={{fontSize: '1.8rem'}}
                        onClick={() => {
                            aggiungiRiga(el)
                        }}
                    ></i>
                </div>
            );
        } else {
            return disegnaValoreElemento(el);
        }
    }

    return (
        <Fragment>
            <ModalMsg
                show={showMsg}
                handleClose={() => setShowMsg(false)}
                testo={modalMsg}/>
            <Dialog
                header={elementoDettagli ? (elementoDettagli.titolo_dettaglio || '') : ''}
                visible={showDettagli}
                style={{width: '50vw'}}
                onHide={onHideDialog}
            >
                <div className="mn-2">
                    {
                        elementoDettagli && elementoDettagli.testo_dettaglio && typeof elementoDettagli.testo_dettaglio != 'undefined' &&
                        elementoDettagli.testo_dettaglio.split('\n').map((paragraph, index) =>
                            <p key={index}>{paragraph}</p>
                        )
                    }
                </div>
            </Dialog>
            <ModalUpdElementoKpiController
                elemento={elementoSelezionato}
                handleClose={hideModalUpdateElemento}
                show={showModalUpdEl}
                aggiungiRiga={aggiungiRiga}
                handleOk={() => {
                    hideModalUpdateElemento();
                    handlerChange();
                }}
                handleKo={() => {
                    hideModalUpdateElemento();
                    handlerErrorUpdateElemento();
                }}
            />
            {
                tabella && tabella.map((livello, idxLivello) =>
                    <Fragment key={idxLivello}>
                        <table className={"sost-tabella-livello-kpi"}>
                            <tbody>
                            {
                                livello.titolo && livello.titolo !== '' &&
                                <tr className={"sost-tr-titolo-livello-kpi"}>
                                    <td
                                        className={"sost-td-titolo-livello-kpi"}
                                        colSpan={livello.colspan}
                                        rowSpan={livello.rowspan}
                                    >{livello.titolo} {getIconaDettaglio(livello)}</td>
                                </tr>
                            }
                            {
                                livello.sottolivelli && livello.sottolivelli.map((sottolivello, idxSottolivello) =>
                                    <tr className={"sost-tr-titolo-sottolivello"} key={idxSottolivello}>
                                        {
                                            sottolivello.elementi && sottolivello.elementi.map((el, idxElemento) =>
                                                <td
                                                    key={idxElemento}
                                                    className={"sost-td-elemento-kpi "
                                                        + getClasse(el)
                                                    }
                                                    colSpan={el.colspan}
                                                    rowSpan={el.rowspan}
                                                    style={{
                                                        width: (el.size && el.size !== '' ? (el.size + '%') : 'auto')
                                                    }}
                                                >
                                                    {
                                                        disegnaElemento(el)
                                                    }
                                                </td>
                                            )
                                        }
                                    </tr>
                                )
                            }
                            </tbody>
                        </table>
                    </Fragment>
                )
            }
        </Fragment>
    );
}